import showToast from "./toast";

export const saveToMemory = (
  key: string,
  item: string | number | any
): void => {
  localStorage.setItem(key, item);
};

export const getFromMemory = (key: string) => {
  return localStorage.getItem(key);
};

export const levelId = getFromMemory("levelId");
export const currentLanguage = getFromMemory("language") as string;

// Get current lesson info from memory
export const currentLessonInfo = () => {
  const lesson = JSON.parse(getFromMemory("CurrentLessonInfo") || "null") as {
    title: string;
    lessonNumber: number;
    lessonId: string;
  } | null;

  if (lesson === null) {
    return { title: null, lessonNumber: null, lessonId: null };
  }
  return {
    title: lesson.title,
    lessonNumber: lesson.lessonNumber,
    lessonId: lesson.lessonId,
  };
};

export const currentLevelInfo = () => {
  const getCurrentLevelInfo = JSON.parse(
    getFromMemory("CurentLevelInfo") || "null"
  ) as { title: string; level: number; levelId: string } | null;

  if (!getCurrentLevelInfo) {
    return { title: null, level: null, levelId: null };
  }

  return {
    title: getCurrentLevelInfo.title,
    level: getCurrentLevelInfo.level,
    levelId: getCurrentLevelInfo.levelId,
  };
};

export const activityIdGenerator = (value: string): string => {
  let newId;
  const last = getFromMemory("lastActivityId");
  const activityIncr = getFromMemory("activityIncr");

  if (activityIncr === "No") {
    return (newId = last as string);
  } else if (activityIncr === "Yes") {
    const lastSerial = last === null ? 0 : last.split("-").pop();
    const next = parseInt(lastSerial as string) + 1;
    const padded = next.toString().padStart(2, "0");
    return (newId = `ACT-${value}-${padded}`);
  } else {
    throw showToast("Apologies, there was an error creating id.", false);
  }
};

export const generateLessonId = (value: string): string => {
  let newId;
  const last = getFromMemory("lastLessonId");
  const isLessonToBeIncreased = getFromMemory("lessonIncr") as string;

  if (isLessonToBeIncreased === "No") {
    return (newId = last as string);
  } else if (isLessonToBeIncreased === "Yes") {
    const lastSerial = last === null ? 0 : last.split("-").pop();
    const next = parseInt(lastSerial as string) + 1;
    const padded = next.toString().padStart(4, "0");
    return (newId = `LSN-${value}-${padded}`);
  } else {
    throw showToast("Id can't be generated at the moment", false);
  }
};

export const getLessonIdRange = (levelNumber: number) => {
  const start = (levelNumber - 1) * 10 + 1;
  const end = levelNumber * 10;
  return { start, end };
};

export const generateLessonIdRange = (
  langCode: string,
  levelNumber: number,
  existingLessonCount: number
) => {
  const { start } = getLessonIdRange(levelNumber);
  const nextSerial = start + existingLessonCount;
  const paddedSerial = nextSerial.toString().padStart(4, "0");

  return `LSN-${langCode}-${paddedSerial}`;
};

// Utility to get the next serial ID for activities or options
type GenericItem = Record<string, any>;
export const getItemWithHighestId = <T extends GenericItem>(
  items: T[],
  idKey: keyof T = "id"
): T | undefined => {
  const extractLastNumber = (value: any): number => {
    if (typeof value !== "string") return -Infinity;
    const matches = value.match(/\d+/g);
    return matches ? parseInt(matches[matches.length - 1], 10) : -Infinity;
  };

  return items.reduce((max, current) => {
    return extractLastNumber(current[idKey]) > extractLastNumber(max[idKey])
      ? current
      : max;
  }, items[0]);
};
